module.exports = __webpack_public_path__ + "img/maker2.2f1de91f.png";